import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/services';

@Component({
  selector: 'app-abundance',
  templateUrl: './abundance.component.html',
  styleUrls: ['./abundance.component.scss']
})
export class AbundanceComponent {
  overviewItems = [
    {
      icon: '../../assets/images/abundance/File Classification.svg',
      title: '文件分类',
      description: '让不同版式、不同尺寸的任务先被清晰整理，再进入后续排料流程。'
    },
    {
      icon: '../../assets/images/abundance/Auto Nesting.svg',
      title: '自动排料',
      description: '快速计算可行排料方案，减少人工摆放时间，提高任务吞吐效率。'
    },
    {
      icon: '../../assets/images/abundance/Environmental protection and energy saving.svg',
      title: '环保节能',
      description: '通过更高利用率的排料方式降低材料浪费，兼顾效率与成本控制。'
    }
  ];

  operationSteps = [
    {
      index: '1',
      title: '导入文件',
      description: '支持将不同来源、不同尺寸的图稿批量导入，让任务在进入排料前先完成统一整理与归类。'
    },
    {
      index: '2',
      title: '一键排料',
      description: '系统自动计算更加紧凑、更加稳定的版面组合，减少人工试错，并让材料利用率保持在可控范围内。'
    },
    {
      index: '3',
      title: '打印输出',
      description: '确认排料结果后即可进入输出环节，适合需要快速反复处理订单的生产型工作流。'
    }
  ];

  reasonCards = [
    {
      icon: '../../assets/images/abundance/Increase productivity.svg',
      title: '提高生产力',
      description: '减少人工排版和重复检查时间，让团队把更多精力放在实际生产与交付上。'
    },
    {
      icon: '../../assets/images/abundance/Ease of use.svg',
      title: '易用性',
      description: '流程更直接，操作门槛更低，适合需要快速上手和稳定执行的日常生产场景。'
    },
    {
      icon: '../../assets/images/abundance/Technical Support.svg',
      title: '技术支持',
      description: '适合长期部署和持续优化的业务环境，为稳定运行和后续扩展提供支持。'
    }
  ];

  industryItems = [
    {
      image: '../../assets/images/abundance/Sheet Metal Processing and Metal Manufacturing.png',
      title: '金属钣材行业'
    },
    {
      image: '../../assets/images/abundance/Clothing and Textile Industry.png',
      title: '纺织服装行业'
    },
    {
      image: '../../assets/images/abundance/Furniture and Woodworking Manufacturing.png',
      title: '家具木工行业'
    },
    {
      image: '../../assets/images/abundance/Packaging and Printing Industry.png',
      title: '包装印刷行业'
    },
    {
      image: '../../assets/images/abundance/Construction and Building Materials Industry.png',
      title: '建筑建材行业'
    }
  ];

  advantageItems = [
    {
      icon: '../../assets/images/abundance/adv1.svg',
      title: '智能套料',
      description: '可以节省您的时间和金钱，同时更有效地使用您的材料 - 您可以完全控制嵌套设置，例如零件数量、板材尺寸和零件旋转，以满足任何切割技术和材料的需求。',
      position: { x: 0, y: 0 },
      isHovered: false
    },
    {
      icon: '../../assets/images/abundance/adv2.svg',
      title: '自动化流程',
      description: '丰芒软件-具备智能排版工具，可以轻松处理复杂的排版任务。支持拖放操作、自动对齐、和自定义布局，让您能够快速高效地完成设计。',
      position: { x: 0, y: 0 },
      isHovered: false
    },
    {
      icon: '../../assets/images/abundance/adv3.svg',
      title: '交互式CAD导入',
      description: '有带有边框或标题栏的 CAD 文件？没问题 - 我们的导入器很聪明，会自动找到要导入的零件，而忽略其他一切。使用我们出色的交互式导入器可以轻松导入您的 CAD 图纸。',
      position: { x: 0, y: 0 },
      isHovered: false
    },
    {
      icon: '../../assets/images/abundance/adv4.svg',
      title: '简洁的用户界面',
      description: '花更少的时间进行设置，将更多的时间用于嵌套和赢得材料。我们设计的一切都干净、现代，最重要的是非常易于使用。我们相信好的软件应该帮助您完成工作，而不是妨碍您！',
      position: { x: 0, y: 0 },
      isHovered: false
    },
    {
      icon: '../../assets/images/abundance/adv5.svg',
      title: '印刷报告',
      description: '为什么不打印出各种套料报告来帮助您的生产团队在切割前后呢？通过使用我们详细的套料报告，在切割套料后更轻松地识别零件，您将零件的拣选速度提高多达 40%或更多！',
      position: { x: 0, y: 0 },
      isHovered: false
    },
    {
      icon: '../../assets/images/abundance/adv6.svg',
      title: '导出嵌套',
      description: '将嵌套布局保存为行业标准 CAD 格式，并提供大量导出选项，以最大限度地兼容您现有的工作流程和工具链。',
      position: { x: 0, y: 0 },
      isHovered: false
    }
  ];

  private animationFrameId: number | null = null;
  private lightBallSize = 50;

  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  openTrialPage() {
    console.log("this.authService.isLoggedIn:", this.authService.isLoggedIn());
    if (!this.authService.isLoggedIn()) {
      this.router.navigate(['/trial']);
    } else {
      // window.location.assign('/nesting');
      this.router.navigate(['/nesting']);
    }
  }

  openContactPage() {
    this.router.navigate(['/contact']);
  }

  onMouseEnter(index: number, event: MouseEvent) {
    const cardElement = event.currentTarget as HTMLElement;
    const cardRect = cardElement.getBoundingClientRect();
    const paddingX = parseFloat(getComputedStyle(cardElement).paddingLeft) + parseFloat(getComputedStyle(cardElement).paddingRight);
    const paddingY = parseFloat(getComputedStyle(cardElement).paddingTop) + parseFloat(getComputedStyle(cardElement).paddingBottom);

    this.advantageItems[index].position.x = event.clientX - cardRect.left - (this.lightBallSize / 2) - (paddingX / 2);
    this.advantageItems[index].position.y = event.clientY - cardRect.top - (this.lightBallSize / 2) - (paddingY / 2);
    this.advantageItems[index].isHovered = true;
  }

  onMouseMove(event: MouseEvent, index: number) {
    const cardElement = event.currentTarget as HTMLElement;
    if (!cardElement) return;

    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }

    this.animationFrameId = requestAnimationFrame(() => {
      const cardRect = cardElement.getBoundingClientRect();
      const paddingX = parseFloat(getComputedStyle(cardElement).paddingLeft) + parseFloat(getComputedStyle(cardElement).paddingRight);
      const paddingY = parseFloat(getComputedStyle(cardElement).paddingTop) + parseFloat(getComputedStyle(cardElement).paddingBottom);

      this.advantageItems[index].position.x = event.clientX - cardRect.left - (this.lightBallSize / 2) - (paddingX / 2);
      this.advantageItems[index].position.y = event.clientY - cardRect.top - (this.lightBallSize / 2) - (paddingY / 2);

      const multiple = 50;
      const calcX = (event.clientY - cardRect.top - cardRect.height / 2) / multiple;
      const calcY = -(event.clientX - cardRect.left - cardRect.width / 2) / multiple;
      cardElement.style.transform = `rotateX(${calcX}deg) rotateY(${calcY}deg)`;
    });
  }

  onMouseLeave(index: number) {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = null;
    }

    const cardElement = document.querySelectorAll('.advantage-card')[index] as HTMLElement;
    if (cardElement) {
      cardElement.style.transform = 'rotateX(0) rotateY(0)';
    }

    this.advantageItems[index].isHovered = false;
  }
}
